export enum InsightTypeEnum {
  ACTION = 1,
  HEALTH = 2,
}

export interface InsightTypeEnumData {
  value: number;
  key: string;
  label: string;
}

export interface InsightType {
  id: number;
  name: string;
  type: InsightTypeEnumData;
  is_active: boolean;
  description?: string | null;
  image?: string | null;
  prompts_count?: number;
  created_at: string;
  updated_at: string;
  prompts?: InsightPrompt[];
}

export interface InsightPrompt {
  id: number;
  insight_type_id: number;
  name: string;
  content: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  type?: {
    id: number;
    name: string;
    type: InsightTypeEnumData;
  };
}
